<form-control
  [group]="form"
  [config]="toggleConfig"
  [control]="toggle"
  data-test-id="brokerAssistanceForm"
>
</form-control>

@if (toggle.value) {
  <form-control
    (selected)="handleBrokerSelected($event)"
    [group]="form"
    [config]="brokerAssistedControlConfig"
    [control]="brokerTypeahead"
    data-test-id="brokerTypeAheadControl"
  >
  </form-control>
}
